import { ONE_MANY_KEY } from 'components/pages/OneMany/constants';
import { useEffect, useRef, useState } from 'react';
import { sendOneManyMiniEvent } from '../../../../../components/pages/OneMany/events';

export const useValidationBlock = (isVisible: boolean, onValidationSuccess: () => void) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isInvalid, setIsInvalid] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const nodeRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const input = inputRef.current;

    if (!input) {
      return undefined;
    }

    const handleInput = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const value = target.value.replace(/\D/g, '');
      target.value = value.slice(0, 1);
    };

    input.addEventListener('input', handleInput);

    return () => {
      input.removeEventListener('input', handleInput);
    };
  }, [isVisible]);

  const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setIsInvalid(!!value && value !== '3');

    if (value === '3') {
      setIsComplete(true);
      onValidationSuccess();
      localStorage.setItem(ONE_MANY_KEY, 'true');
      sendOneManyMiniEvent('GO_TO_CONGRAT')
    } else {
      if (value) {
        sendOneManyMiniEvent('CAPCHA_WRONG', value)
      }
      setIsComplete(false);
    }
  };

  return {
    nodeRef,
    inputRef,
    isInvalid,
    onInput,
    isComplete,
  };
};
